import {
  DashboardViewRegion,
  DashboardViewRegionsFlatListMap,
  DashboardViewRegionsParentMap,
} from '../../types/dashboard-view-regions.types';

/** Unique identifier for the dashboard view regions state. */
export const dashboardViewRegionsUniqueStateId = '_DashboardViewRegions_';

/** Describes dashboard view regions state fields. */
export interface DashboardViewRegionsStateModel {
  /** List of available view regions. */
  viewRegionList: DashboardViewRegion[];

  /** Map of view regions id and their parents id. */
  viewRegionsParentMap: DashboardViewRegionsParentMap;

  /** Map of view regions id and the related view regions. */
  viewRegionsFlatListMap: DashboardViewRegionsFlatListMap;

  /**
   * Selected view region of the dashboard.
   * Usually represents the currently focused or active view region in the dashboard.
   */
  selectedViewRegion: DashboardViewRegion;

  /**
   * Selected view region of the first (highest) level (displayed as group in the carousel).
   * Usually represents a group of regions (like a brain, muscle, skeleton, etc.).
   */
  firstLevelViewRegion: DashboardViewRegion;

  /**
   * Selected view region of the second level (displayed as a region button in the carousel).
   * Usually represents a specific organ or body part (like Ventricles, Thalamus, etc.).
   */
  secondLevelViewRegion: DashboardViewRegion;

  /**
   * Selected view region of the third level (displayed as a part in the tree view).
   * Usually represents a specific part of the organ or body part (like Left Thalamus, Inferior Ventricles, etc.).
   */
  thirdLevelViewRegion: DashboardViewRegion;

  /**
   * Selected view region of the fourth level (displayed as a sub-part in the tree view).
   * Usually represents a specific sub-part of the organ or body part (like Left Inferior Ventricle, Right Inferior Ventricle, etc.).
   */
  fourthLevelViewRegion: DashboardViewRegion;

  /**
   * Selected view region of the fifth level  (displayed as a sub-sub-part in the tree view).
   * Usually represents a specific sub-sub-part of the organ or body part (like Left Inferior Ventricle, Right Inferior Ventricle, etc.).
   */
  fifthLevelViewRegion: DashboardViewRegion;
}

/** Default values for the dashboard view regions state initialization and reset. */
export const dashboardViewRegionsStateDefault: DashboardViewRegionsStateModel = {
  viewRegionList: [],

  viewRegionsParentMap: null,
  viewRegionsFlatListMap: null,

  selectedViewRegion: null,

  firstLevelViewRegion: null,
  secondLevelViewRegion: null,
  thirdLevelViewRegion: null,
  fourthLevelViewRegion: null,
  fifthLevelViewRegion: null,
};
